export enum autoplayAssetConfig {

}